<template>
	<div>
		<base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9">
			<div class="row pb-3">
				<div class="col">
					<div class="card shadow">
						<div class="card-header bg-transparent">
							<div>
								<h3>Crear una nueva Cotización</h3>
							</div>
						</div>
						<div class="card-body">
							<div class="row px-lg-4 mb-4">
								<div class="col">
									<label class="form-control-label">Cliente *</label>
									<multiselect
										v-model="selectedCustomer"
										placeholder="Busca un Cliente"
										track-by="CardCode"
										:options="customers"
										:disabled="!customers.length > 0"
										:loading="!customers.length > 0"
										@select="getCustomer"
										:custom-label="x => {return `${x.CardCode} - ${x.CardName}`}">
									</multiselect>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row py-3">
				<div class="col">
					<div class="card shadow">
						<div class="card-header">
							<h3>Cotización</h3>
						</div>
						<div class="card-body">
							<h6 class="heading-small text-muted mb-4">Información General</h6>
							<div class="row pl-lg-4">
								<div class="col-6 col-xl-3">
									<base-input
										v-model="federalTaxID"
										inputClasses="input-group-alternative"
										label="RFC"
										placeholder="RFC"
										disabled>
									</base-input>
								</div>
								<div class="col-6 col-xl-3">
									<base-input
										v-model="phone1"
										inputClasses="input-group-alternative"
										label="Teléfono"
										placeholder="Teléfono"
										disabled>
									</base-input>
								</div>
								<div class="col-12 col-xl-3">
									<base-input
										v-model="emailAddress"
										inputClasses="input-group-alternative"
										label="Correo electrónico"
										placeholder="Correo electrónico"
										disabled>
									</base-input>
								</div>
								<div class="col-12 col-xl-3">
									<label class="form-control-label">Enviar a *</label>
									<multiselect
										v-model="selectedAddress"
										placeholder="Enviar a"
										:options="addressesOptions"
										class="mb-4"
										label="AddressName"
										:disabled="!addressesOptions.length > 0"
										:show-labels="false">
										<template slot="option" slot-scope="props">
											<div v-if="props.option.AddressName">
												<span class="font-weight-bold">{{props.option.AddressName}}</span>
												<br>
												<span class="font-weight-normal">{{props.option.Street}} {{props.option.StreetNo}}</span>
												<br>
												<span class="font-weight-normal">{{props.option.Block}}</span>
												<br>
												<span class="font-weight-normal">{{[props.option.City, props.option.State, props.option.ZipCode].filter(x => x).join(', ')}}</span>
											</div>
										</template>
									</multiselect>
								</div>
								<div class="col-12 col-xl-3">
									<label class="form-control-label">¿Es Proyecto? *</label>
									<multiselect
										v-model="selectedProject"
										placeholder="Proyecto"
										:options="projectOptions"
										label="name"
										track-by="code"
										class="mb-4"
										:show-labels="false">
									</multiselect>
								</div>
								<div class="col-12 col-xl-3">
									<label class="form-control-label">Vendedor *</label>
									<multiselect
										v-model="selectedSalesPerson"
										placeholder="Selecciona un vendedor"
										label="SalesEmployeeName"
										track-by="SalesEmployeeCode"
										:options="salesPersonOptions"
										:disabled="!salesPersonOptions.length > 0"
										:loading="!salesPersonOptions.length > 0"
										class="mb-4"
										:show-labels="false"
										>
									</multiselect>
								</div>
								<div class="col-6 col-xl-3">
									<label class="form-control-label">Moneda *</label>
									<multiselect
										v-model="docCurrency"
										placeholder="Selecciona Moneda"
										:options="currencyOptions"
										class="mb-4"
										:show-labels="false">
									</multiselect>
								</div>
								<div class="col-6 col-xl-3">
									<label class="form-control-label">Almacén *</label>
									<multiselect
										v-model="warehouse"
										placeholder="Selecciona un almacén"
										:options="warehouseOptions"
										class="mb-4"
										:show-labels="false">
									</multiselect>
								</div>
								<div class="col-12 col-xl-6">
									<label class="form-control-label">CFDI *</label>
									<multiselect
										v-model="selectedCfdi"
										placeholder="Selecciona CFDI"
										class="mb-4"
										:options="cfdiOptions"
										label="name"
										track-by="code"
										:show-labels="false"
										:disabled="!['federicoflores@canplast.com.mx',
																'bereniceterrazas@canplast.com.mx',
																'darinkahernandez@canplast.com.mx',
																'aideehernandez@canplast.com.mx',
																'dannasandoval@canplast.com.mx',
																'leslysifuentes@canplast.com.mx',
																'alfredoreyes@canplast.com.mx',
																'carlosjimenez@canplast.com.mx'].includes(user.email) || !customer">
									</multiselect>
								</div>
								<div class="col-12 col-xl-6">
									<base-input
										v-model="numAtCard"
										inputClasses="input-group-alternative"
										label="Referencia"
										placeholder="Referencia (Opcional)">
									</base-input>
								</div>
								<div class="col-12 col-xl-12">
									<base-input
										v-model="comments"
										inputClasses="input-group-alternative"
										label="Comentarios"
										placeholder="Comentarios (Opcional)">
									</base-input>
								</div>
							</div>
							<hr>
							<h6 class="heading-small text-muted mb-4">Artículos</h6>
							<div class="d-xl-flex pl-lg-4">
								<div class="row" style="flex: 1">
									<div class="col-12 col-xl-8">
										<label class="form-control-label">Artículo *</label>
										<div class="d-flex align-items-center mb-4 ">
											<multiselect
												v-model="articleItem"
												placeholder="Selecciona un artículo"
												:options="productsOptions"
												:disabled="loadingItems"
												:loading="loadingItems"
												:custom-label="x => {return `${x.ItemCode} (${x.ItemName})`}"
												track-by="ItemCode"
												@select="selectArticle"
												:show-labels="false"
												>
											</multiselect>
											<div v-b-popover.hover.top="'Actualizar artículos'"	class="ml-2">
												<base-button	
													@click="getItems()"
													icon="fa fa-redo"
													type="primary"
													size="sm"
													:disabled="loadingItems">
												</base-button>
											</div>
										</div>
									</div>
									<div class="col-6 col-xl-2">
										<base-input
											v-model="articleUnitPrice"
											:disabled="loadingArticle"
											inputClasses="input-group-alternative"
											type="number"
											label="Precio unitario"
											min="0"
											required>
										</base-input>
									</div>
									<div class="col-6 col-xl-2">
										<base-input
											v-model="articleQuantity"
											inputClasses="input-group-alternative"
											label="Cantidad"
											type="number"
											min="0"
											required>
										</base-input>
									</div>
									<div class="col-12" v-if="substitutes && substitutes.length">
										<label class="form-control-label">Sustituto</label>
										<multiselect
											v-model="articleSubstitute"
											placeholder="Selecciona un sustituto (Opcional)"
											:options="substitutes"
											:disabled="loadingArticle || !substitutes"
											:loading="loadingArticle"
											:custom-label="x => {return `${x[`Codigo Sustituto`]} (${x['Descripcion Sustituto']})`}"
											track-by="Codigo Sustituto"
											class="mb-4"
											>
										</multiselect>
									</div>
								</div>
								<div class="ml-xl-4 d-flex justify-content-end align-items-end">
									<base-button
										@click="addArticle()"
										icon="fa fa-plus"
										class="mb-4"
										:disabled="!articleItem || !articleQuantity || !articleUnitPrice || loadingArticle">
										Agregar
									</base-button>
								</div>
							</div>
						</div>
						<div class="table-responsive">
							<base-table thead-classes="thead-light" :data="articlesList" class="mb-4">
								<template v-slot:columns>
									<th class="pl-5">Artículo</th>
									<th>Descripción</th>
									<th>Cantidad</th>
									<th>Precio unitario</th>
									<th>Subtotal</th>
									<th></th>
									<th></th>
								</template>
								<template  v-slot:default="{ row, index }">
									<th scope="row" class="pl-5">
										{{row.ItemCode}}
										<p class="h5 text-primary m-0" v-if="row.U_SubCode">
											Sustituto: {{row.U_SubCode}}
										</p>
									</th>
									<th scope="row">
										{{row.ItemName}}
										<p class="h5 text-primary m-0" v-if="row.U_SubDescription">
											{{row.U_SubDescription}}
										</p>
									</th>
									<th scope="row">
										{{row.Quantity}}
									</th>
									<th scope="row">
										${{row.UnitPrice}}
									</th>
									<th scope="row">
										{{new Intl.NumberFormat('mx-MX', { style: 'currency', currency: currencyIso })
										.format(row.UnitPrice*row.Quantity)}}
										+ IVA
									</th>
									<th scope="row">
										<base-button
											@click="openStock(row)"
											type="default"
											size="sm">
											Existencias
										</base-button>
									</th>
									<th scope="row">
										<base-button
											@click="removeArticle(index)"
											type="danger"
											size="sm"
											icon="fa fa-trash">
										</base-button>
									</th>
								</template>
							</base-table>
						</div>
						<center v-if="articlesList.length === 0" class="py-2">
							<i class="fa fa-plus text-muted" aria-hidden="true"></i>
							<p class="text-muted text-sm font-weight-normal py-2">No hay artículos seleccionados</p>
						</center>
						<div class="card-footer">
							<div :class="['d-flex', savingQuotation ? 'justify-content-center' : 'justify-content-end' ] ">
								<base-button
									@click="saveQuotation()"
									:disabled="!selectedCustomer ||
                    !warehouse ||
                    !docCurrency ||
                    !selectedSalesPerson ||
                    !selectedCfdi ||
                    !selectedProject ||
                    !selectedAddress ||
                    articlesList.length === 0"
									v-if="!savingQuotation"
									icon="fa fa-check">
									Generar cotización
								</base-button>
								<base-loader v-if="savingQuotation" text="Generando cotización"></base-loader>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
    <b-modal hide-footer size="xl" title="Existencias" v-model="showItemStock" bodyClass="p-0">
      <div v-if="currentItem" class="modal-body mt-n3 py-0">
        <span class="h3" style="user-select: all;">{{currentItem.ItemCode}}</span> 
				<span class="font-weight-normal h4 text-muted"> ({{currentItem.ItemName}})</span>
        <h5 class="font-weight-bold text-body mt-2">Máster: 
					<span style="user-select: all;">{{currentItem.MasterCode}}</span> 
				</h5>
      </div>
      <data-table id="dt_item_stock" class="pb-4" v-bind="itemStockTable"/>
    </b-modal>
	</div>
</template>
<script>
import BaseLoader from "@/components/BaseLoader.vue"
import { getAuth } from "firebase/auth";
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import DTLoader from '@/components/DataTable/DTLoader.vue'
import currency from '@/data/currency.json'
export default {
	components: {
		Multiselect,
		BaseLoader
	},
	data() {
		return {
			HANA_URL: process.env.VUE_APP_HANA_URL,
			user: null,
			customers: [],
			selectedCustomer: null,
			customer: null,
			federalTaxID: null,
			emailAddress: null,
			phone1: null,
			warehouseOptions:["CUU-02", "MEX-02", "GDL-02", "QRO-02", "MTY-02", "MID-02"],
			currencyOptions: ["MXP", "USD", "EUR"],
			cfdiOptions:[
          {code: 'G01',  name: "G01 - Adquisición de mercancías"},
          {code: 'G02',  name: "G02 - Devoluciones, descuentos o bonificaciones"},
          {code: 'G03',  name: "G03 - Gastos en general"},
          {code: 'I01',  name: "I01 - Construcciones"},
          {code: 'I02',  name: "I02 - Mobilario y equipo de oficina por inversiones"},
          {code: 'I03',  name: "I03 - Equipo de transporte"},
          {code: 'I04',  name: "I04 - Equipo de cómputo y accesorios"},
          {code: 'I05',  name: "I05 - Dados, troqueles, moldes, matrices y herramental"},
          {code: 'I06',  name: "I06 - Comunicaciones telefónicas"},
          {code: 'I07',  name: "I07 - Comunicaciones satelitales"},
          {code: 'D01',  name: "D01 - Honorarios médicos, dentales y gastos hospitalarios"},
          {code: 'D02',  name: "D02 - Gastos médicos por incapacidad o discapacidad"},
          {code: 'D03',  name: "D03 - Gastos funerales"},
          {code: 'D04',  name: "D04 - Donativos"},
          {code: 'D05',  name: "D05 - Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)"},
          {code: 'D06',  name: "D06 - Aportaciones voluntarias al SAR"},
          {code: 'D07',  name: "D07 - Primas por seguros de gastos médicos"},
          {code: 'D08',  name: "D08 - Gastos de transportación escolar obligatoria"},
          {code: 'D09',  name: "D09 - Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones"},
          {code: 'D10',  name: "D10 - Pagos por servicios educativos (colegiaturas)"},
          {code: 'P01',  name: "P01 - Por definir"},
      ],
			projectOptions: [
				{code:"Y", name: "Si"},
				{code:"N", name: "No"}
			],
			salesPersonOptions: [],
			addressesOptions: [],
			productsOptions: [],
			substitutes: [],
			selectedSalesPerson: null,
			docCurrency: null,
			warehouse: null,
			selectedCfdi: null,
			selectedProject: null,
			selectedAddress: null,
			numAtCard: null,
			comments: null,
			articlesList: [],
			articleItem: null,
			articleQuantity: null,
			articleUnitPrice: null,
			articleSubstitute: null,
			savingQuotation: false,
			loadingItems: false,
			loadingArticle: false,
			showItemStock: false,
			currentItem: null,
			itemStockTable: {
          data: [],
          columns: [],
          defaultPerPage: 100,
          isLoading: true,
          sortingMode: "single",
          showDownloadButton: false,
          loadingComponent: DTLoader,
          lang: "es",
          text: {
            previousButtonText: "❮",
            nextButtonText: "❯", 
            searchText: "Buscar"
          },
        }
		};
	},
	created() {
		this.user = getAuth().currentUser;

		axios.get(`/api/customers`)
    .then(response => {
			this.customers = response.data.value;
			if (this.$route.params.cardCode) {
				this.selectedCustomer = this.customers.find(x => x.CardCode === this.$route.params.cardCode);
				this.getCustomer(this.selectedCustomer);
			}
    }).catch(error => {
      console.error(error);
    });

		axios.get(`/api/sales_persons`)
		.then((response) => {
			this.salesPersonOptions = response.data.value;
		}).catch((error) => {
			console.error(error);
		});
		this.getItems();
	},
	methods: {
		getCustomer(customer){
			this.selectedAddress = null;
			axios.get(`/api/customers/${customer.CardCode}`)
			.then(response => {
				this.customer = response.data;
				this.federalTaxID = this.customer.FederalTaxID;
				this.emailAddress = this.customer.EmailAddress;
				this.phone1 = this.customer.Phone1;
				this.selectedCfdi = this.cfdiOptions.find(x => x.code === this.customer.U_B1SYS_MainUsage)
				this.addressesOptions = this.customer.BPAddresses.filter(x => x.AddressName !== 'Domicilio Fiscal');
			}).catch(error => {
				console.error(error);
			});
		},
		getItems(){
			this.loadingItems = true;
			axios.get(`/api/items/list`)
			.then((response) => {
				this.productsOptions = response.data;
				this.loadingItems = false;
			}).catch((error)=> {
				console.error(error);
			});
		},
		selectArticle(article){
			this.loadingArticle = true;
			this.articleSubstitute = null;
			axios.get(`/api/items/itemprice/${article.ItemCode}`)
			.then((response) => {
				this.articleItem = response.data;
        this.articleUnitPrice = response.data.ItemPrices[0].Price;
				this.loadingArticle = false;
			}).catch((error) => {
				console.error(error);
			});
			
			axios.get(`${this.HANA_URL}/api/item/sub_items_list?ItemCode=${article.ItemCode}`)
			.then(res => {
				if(res.data.length){
					this.substitutes = res.data;
				}
			}).catch(err => {
				console.error(err); 
			});
    },
	addArticle(){
		this.articlesList.push({
			"ItemCode": this.articleItem.ItemCode,
			"ItemName": this.articleItem.ItemName,
			"Quantity": this.articleQuantity,
			"UnitPrice": this.articleUnitPrice,
			"U_SubCode": this.articleSubstitute ? this.articleSubstitute[`Codigo Sustituto`] : null,
			"U_SubDescription": this.articleSubstitute ? this.articleSubstitute[`Descripcion Sustituto`] : null,
		});

		this.articleItem = null;
		this.articleQuantity = null;
		this.articleUnitPrice = null;
		this.articleSubstitute = null;
		this.substitutes = null;
    },
		openStock(item){
			this.itemStockTable.columns = [
				{
					title: "Almacén",
					key: "WarehouseCode"
				},
				{
					title: "Master (M2) Disponible",
					key: "MasterStock",
					type: "number"
				},
			]
			this.currentItem = item;

			if(!item.ItemCode.toUpperCase().endsWith('M2')){
				this.itemStockTable.columns.splice(1, 0, {
          title: "ML Disponibles", 
          key: "ItemStock",
          type: "number"
        })
			}

			this.showItemStock = true;
			this.itemStockTable.data = item.Stock;
      this.itemStockTable.isLoading = false;
		},
		removeArticle(index){
      this.articlesList.splice(index, 1);
    },
		saveQuotation(){
			this.savingQuotation = true;
			var documentLines = this.articlesList.map((x) => {
				return {
					"ItemCode": x.ItemCode,
					"Quantity": x.Quantity,
					"WarehouseCode": this.warehouse,
					"UnitPrice": x.UnitPrice,
					"FreeText": `Registrado por ${this.user.displayName} desde la Nueva Consola de Administración`,
					"U_SubCode": x.U_SubCode,
					"U_SubDescription": x.U_SubDescription,
				}
      });
			var json = {
				"U_External_User": this.user.displayName,
				"CardCode": this.customer.CardCode,
				"DocCurrency": this.docCurrency,
				"SalesPersonCode": this.selectedSalesPerson.SalesEmployeeCode,
				"NumAtCard": this.numAtCard,
				"Comments": this.comments,
				"ShipFrom": this.selectedAddress.AddressName,
				"U_B1SYS_MainUsage": this.selectedCfdi.code,
				"U_TS_UsoCFDI40": this.selectedCfdi.code,
				"U_Project": this.selectedProject.code,
				"DocumentLines": documentLines
			}

			axios.post(`/api/quotes`, json).then(response => {
				if(!response.data.sl_err){
					this.downloadPdfFile(response.data);
					this.$swal("Cotización Creada", `Cotización #${response.data.DocNum}`, "success");
				} else {
					this.$swal("Error", response.data.sl_err.error.message.value, "error");
				}
				this.savingQuotation = false;
			}).catch(error => {
				console.error(error);
				this.savingQuotation = false;
      });
    },
		downloadPdfFile(obj){
			let json = {
				"DocCode": "QUT20007",
				"Pairs": {
					"DocKey@": obj.DocEntry
				}
			};
			axios.post(`/api/pdf_file`,json)
			.then(response => {
				let link = document.createElement('a');
				link.download = `Cotización_${obj.DocNum}.pdf`;
				link.href =  response.data.base64;
				link.click();
			}).catch(error => {
				console.error(error); 
			})
		},
	},
	mounted() {
	},
	computed:{
      currencyIso(){
        if(this.docCurrency){
          return currency.find(x => x.key === this.docCurrency).iso;
        } else {
          return 'MXN';
        }
      }
    }
}
</script>
<style>
#dt_item_stock  > .data-table-pagination {
  grid-area: pagination / pagination / pagination / download;
}
</style>